import React, { useEffect, useMemo, useState } from 'react';
import { ShoppingCartIcon, XIcon } from 'lucide-react';
const buyers = [{
  name: 'Carlos M.',
  city: 'Bogotá'
}, {
  name: 'María R.',
  city: 'Medellín'
}, {
  name: 'Andrés T.',
  city: 'Cali'
}, {
  name: 'Laura K.',
  city: 'Barranquilla'
}, {
  name: 'David M.',
  city: 'Cartagena'
}, {
  name: 'Jessica L.',
  city: 'Bucaramanga'
}, {
  name: 'Santiago P.',
  city: 'Pereira'
}, {
  name: 'Valentina N.',
  city: 'Manizales'
}, {
  name: 'Cristian H.',
  city: 'Santa Marta'
}, {
  name: 'Camila S.',
  city: 'Ibagué'
}, {
  name: 'Felipe B.',
  city: 'Villavicencio'
}, {
  name: 'Daniela D.',
  city: 'Pasto'
}, {
  name: 'Julián J.',
  city: 'Cúcuta'
}, {
  name: 'Natalia C.',
  city: 'Armenia'
}, {
  name: 'Kevin A.',
  city: 'Neiva'
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(0);
  const [spotsLeft, setSpotsLeft] = useState(51);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showFirst = setTimeout(() => {
      setSpotsLeft(50);
      setVisible(true);
    }, 12000);
    return () => clearTimeout(showFirst);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentBuyer(prev => (prev + 1) % buyers.length);
        setSpotsLeft(prev => Math.max(1, prev - 1));
        setVisible(true);
      }, 2000);
    }, 25000);
    return () => clearInterval(cycle);
  }, [dismissed]);
  // Memoize timeAgo per buyer to avoid random recalculation on every render
  const timeAgo = useMemo(() => Math.floor(Math.random() * 5 + 1), [currentBuyer]);
  if (dismissed || !visible) return null;
  const buyer = buyers[currentBuyer];
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm animate-slide-up" style={{
    animation: 'slideUp 0.4s ease-out'
  }} data-id="element-558">
      <style data-id="element-559">{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <div className="rounded-lg shadow-lg p-4 flex items-start gap-3 border" style={{
      backgroundColor: 'white',
      borderColor: '#e2e8f0'
    }} data-id="element-560">
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{
        backgroundColor: '#f59e0b'
      }} data-id="element-561">
          <ShoppingCartIcon className="h-5 w-5" style={{
          color: '#0f172a'
        }} data-id="element-562" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-563">
          <p className="text-sm font-bold" style={{
          color: '#0f172a'
        }} data-id="element-564">
            {buyer.name}{' '}
            <span className="font-normal" style={{
            color: '#64748b'
          }} data-id="element-565">
              de {buyer.city}
            </span>
          </p>
          <p className="text-sm" style={{
          color: '#0f172a'
        }} data-id="element-566">
            compró la Guía LPM™ por{' '}
            <strong style={{
            color: '#f59e0b'
          }} data-id="element-567">
              $49.999
            </strong>
          </p>
          <p className="text-xs mt-1" style={{
          color: '#dc2626'
        }} data-id="element-568">
            🔥 Solo quedan <strong data-id="element-569">{spotsLeft}</strong> cupos de 300
          </p>
          <p className="text-xs mt-0.5" style={{
          color: '#94a3b8'
        }} data-id="element-570">
            hace {timeAgo} min
          </p>
        </div>
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 p-1 rounded hover:bg-gray-100 transition-colors cursor-pointer" aria-label="Cerrar notificación" data-id="element-571">
          <XIcon className="h-4 w-4" style={{
          color: '#94a3b8'
        }} data-id="element-572" />
        </button>
      </div>
    </div>;
}